import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../store/user_slice'
import { useTranslation } from 'react-i18next';

const LogoutButton: React.FC = () => {
  const {t} = useTranslation()
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/'); 
  };

  return (
    <button className='w-full text-start' onClick={handleLogout}>
      {t('Logout')}
    </button>
  );
};

export default LogoutButton;
